import ConsultationScheduleViewController from "./consultation-schedule-view-controller";

class ConsultationEditViewController extends ConsultationScheduleViewController {
  prepareSubmit(values) {
    if (
      this.screen.fields.some(
        field =>
          field?.type === "formCalendarPicker" ||
          field?.type === "formCalendarPickerSlots"
      )
    ) {
      return values;
    }
    return super.prepareSubmit(values);
  }
}

export default ConsultationEditViewController;
